<template>
  <div>
    <nav-bar/>
    <div id="contactUs" class="page-padding">
      <div class="container">
        <div class="row aboutUs-txt">
          <div class="col-10 mx-auto ">
            <h4 class="title-border-bottom text-center pb-5 mt-8">تماس با ما</h4>
            <div class="text-center px-5">
              <v-img :src="$replaceHttps(fileUrl)"></v-img>
              <a class="mt-3" v-if="link !== null" :href="link" target="_blank">
                <v-btn color="primary">لینک</v-btn>
              </a>
              <div class="mt-4 font-16" v-html="descriptions"></div>
              <!--                                <div class="mt-4">شماره دفتر مرکزی: {{officePhone}}</div>-->
              <!--                                <div class="mt-4">آدرس دفتر مرکزی:</div>-->
              <!--                                <div class="mt-3">{{officeAddress}}</div>-->
            </div>
          </div>
          <div class="col-12">
            <h4 class="title-border-bottom text-center pb-5 mt-8">شبکه های اجتماعی</h4>
            <div class="row">
              <div v-for="item in socialNetworkItems" :key="item.SocialNetworkID"
                   class="col-auto mt-9 text-center">
                <div v-if="item.IsActive">
                  <a :href="item.Link" target="_blank">
                    <v-img :src="$replaceHttps(item.FileUrl)" :alt=item.name height="75" width="75" contain></v-img>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!--          <div class="col-12">
                      <GmapMap
                          ref="mapRef"
                          :center="myCoordinates"
                          :options='{ fullscreenControl: false, mapTypeControl: false }'
                          :zoom="zoom"
                          style="height:360px"
                      >
                        <GmapMarker
                            v-for='(marker,index) in markers'
                            :key="index"
                            :animation="2"
                            :clickable="true"
                            :position="marker"
                            @click="center=marker"/>
                      </GmapMap>
                    </div>-->
        </div>
      </div>
    </div>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import NavBar from "@/Ticketing/components/navBar";

export default {
  name: "contactUs",
  components: {NavBar},
  metaInfo() {
    return {
      title: 'تیکتینگ-تماس با ما '
    }
  },
  data: () => ({
    showLoaderDialog: false,
    descriptions: '',
    fileUrl: '',
    link: null,
    socialNetworkItems :[]
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetPage?typePage=2", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            console.log(json)
            this.aboutUsText = json.Description
            this.fileUrl = json.FileUrl
            this.link = json.Link
            this.showLoaderDialog = false
            this.getSocial()
          })
          .catch(error => console.log('error', error));
    },
    getSocial(){
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetSocialNetworks", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.socialNetworkItems = JSON.parse(result).filter(x => x.IsActive)
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>